module.exports = __webpack_public_path__ + "img/img-serviceFour.2244b3fd.png";